
const locations = [
  {
    name: 'Hospital Belisario Domínguez',
    address: 'Av. Belisario Domínguez 288, Oblatos, 44380 Guadalajara, Jal.',
    phone: '+52 33 1864 8274',
    whatsapp: '+52 33 1864 8274',
    hours: 'Lunes a Viernes: 8:00 AM - 6:00 PM\nSábados: 9:00 AM - 2:00 PM',
    mapUrl: 'https://maps.google.com/maps?q=Av.+Belisario+Dom%C3%ADnguez+288,+Oblatos,+44380+Guadalajara,+Jal.&output=embed',
    image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/1caf18bc20a399d8b3f2a595b67d5d98.png'
  },
  {
    name: 'Hospital Americas',
    address: 'Av. de las Américas 932, Ayuntamiento, 44620 Guadalajara, Jal.',
    phone: '+52 33 1864 8274',
    whatsapp: '+52 33 1864 8274',
    hours: 'Lunes a Viernes: 7:00 AM - 8:00 PM\nSábados: 8:00 AM - 4:00 PM',
    mapUrl: 'https://maps.google.com/maps?q=Av.+de+las+Am%C3%A9ricas+932,+Ayuntamiento,+44620+Guadalajara,+Jal.&output=embed',
    image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/21e1560a864b49a162332ed0e1cda9a9.png'
  },
  {
    name: 'Centro de Salud La Cima',
    address: 'Av. la Cima 757, La Cima, 45134 Zapopan, Jal.',
    phone: '+52 33 1864 8274',
    whatsapp: '+52 33 1864 8274',
    hours: 'Lunes a Viernes: 8:00 AM - 7:00 PM\nSábados: 9:00 AM - 3:00 PM',
    mapUrl: 'https://maps.google.com/maps?q=Centro+Medico+La+Cima+Guadalajara&output=embed',
    image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/78d44788413bbe2f353fa4f9d0fe2f24.png'
  }
];

export default function Locations() {
  return (
    <section id="ubicaciones" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111317] mb-4">
            Nuestras Ubicaciones
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Te atendemos en los mejores hospitales y centros médicos de Guadalajara
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              {/* Imagen del hospital */}
              <div className="h-48 bg-gray-200 relative overflow-hidden">
                <img 
                  src={location.image}
                  alt={`Exterior del ${location.name}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#111317] mb-3">
                  {location.name}
                </h3>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-[#1B84FF] mr-3 mt-1 flex-shrink-0"></i>
                    <p className="text-gray-600 text-sm">
                      {location.address}
                    </p>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-phone-line text-[#1B84FF] mr-3 flex-shrink-0"></i>
                    <a href={`tel:+523318648274`} className="text-gray-600 text-sm hover:text-[#1B84FF] transition-colors">
                      {location.phone}
                    </a>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-whatsapp-line text-[#1B84FF] mr-3 flex-shrink-0"></i>
                    <a 
                      href={`https://wa.me/523318648274`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 text-sm hover:text-[#1B84FF] transition-colors"
                    >
                      {location.whatsapp}
                    </a>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-time-line text-[#1B84FF] mr-3 mt-1 flex-shrink-0"></i>
                    <div className="text-gray-600 text-sm">
                      {location.hours.split('\n').map((line, lineIndex) => (
                        <p key={lineIndex}>{line}</p>
                      ))}
                    </div>
                  </div>
                </div>
                
                {/* Mapa embebido */}
                <div className="mb-4 rounded-lg overflow-hidden">
                  <iframe
                    src={location.mapUrl}
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={`Ubicación de ${location.name}`}
                  ></iframe>
                </div>
                
                <div className="flex space-x-3">
                  <button 
                    onClick={() => window.open(`https://maps.google.com/?q=${encodeURIComponent(location.address)}`, '_blank')}
                    className="flex-1 bg-[#0B2A4A] text-white py-2 px-4 rounded-lg hover:bg-[#1B84FF] transition-colors cursor-pointer whitespace-nowrap text-sm"
                  >
                    <i className="ri-direction-line mr-2"></i>
                    Cómo llegar
                  </button>
                  
                  <button 
                    onClick={() => window.open(`https://wa.me/523318648274?text=${encodeURIComponent('Hola, me interesa agendar una consulta en ' + location.name)}`, '_blank')}
                    className="flex-1 bg-[#25D366] text-white py-2 px-4 rounded-lg hover:bg-[#128C7E] transition-colors cursor-pointer whitespace-nowrap text-sm"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>
                    WhatsApp
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
